module.exports = __webpack_public_path__ + "img/poster.8a7c3f12.png";